import React from 'react';
import { Box, ListItemButton, Tooltip } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import useNavigationItems from '../hooks/useNavigationItems';
import { DESKTOP_NAV_WIDTH } from './layoutSizes';

// DESKTOP LAYOUT: vertical sidebar nav that replaces the BottomNavBar on desktop (≥960px)
const DesktopNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = useNavigationItems();

  const isActive = (path) => {
    if (path === '/leads') return location.pathname.startsWith('/leads');
    if (path === '/settings') return location.pathname.startsWith('/settings');
    if (path === '/metrics') return location.pathname.startsWith('/metrics');
    return location.pathname === path;
  };

  return (
    <Box
      sx={{
        width: DESKTOP_NAV_WIDTH,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
        borderRight: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        py: 2,
        gap: 1,
      }}
    >
      {/* Nav items */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1 }}>
        {/* ListItemButton (como o Drawer do dashboard): fundo e hover do item
            ativo vêm do `selected` nativo; só a cor do ícone é customizada. */}
        {navItems.map((item) => (
          <Tooltip key={item.path} title={item.label} placement="right">
            <ListItemButton
              selected={isActive(item.path)}
              onClick={() => navigate(item.path)}
              sx={{
                width: 44,
                height: 44,
                p: 0,
                flexGrow: 0,
                borderRadius: 2,
                justifyContent: 'center',
                color: 'text.secondary',
                '&.Mui-selected': { color: 'primary.main' },
              }}
            >
              {item.icon}
            </ListItemButton>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};

export default DesktopNav;
